import { Mic } from "lucide-react";
import { motion } from "framer-motion";

export default function HoldToSpeak({ active, onStart, onEnd, disabled }) {
  return (
    <motion.button
      type="button"
      disabled={disabled}
      onMouseDown={onStart}
      onMouseUp={onEnd}
      onMouseLeave={(e) => { if (active) onEnd?.(e); }}
      onTouchStart={(e) => { e.preventDefault(); onStart?.(e); }}
      onTouchEnd={(e) => { e.preventDefault(); onEnd?.(e); }}
      whileTap={{ scale: 0.96 }}
      animate={active ? { scale: [1, 1.04, 1] } : { scale: 1 }}
      transition={active ? { duration: 1.3, repeat: Infinity, ease: "easeInOut" } : { duration: 0.2 }}
      className={`relative inline-flex items-center justify-center w-28 h-28 rounded-full select-none transition-colors ${
        active
          ? "bg-[var(--rl-accent)] text-white"
          : "bg-[var(--rl-text)] text-white hover:bg-[var(--rl-brand)]"
      } ${disabled ? "opacity-40 cursor-not-allowed" : "cursor-pointer"}`}
      data-testid="hold-to-speak-btn"
      aria-label="Hold to speak"
    >
      {active && (
        <span className="absolute inset-0 rounded-full recording-pulse" />
      )}
      <Mic className="w-10 h-10 relative" />
    </motion.button>
  );
}
